import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

import { api, TOKEN_KEY } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => window.localStorage.getItem(TOKEN_KEY));
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mustChangePassword, setMustChangePassword] = useState(false);

  useEffect(() => {
    const loadProfile = async () => {
      if (!token) {
        setUser(null);
        setLoading(false);
        return;
      }

      try {
        const { data } = await api.get("/api/auth/me");
        setUser(data);
        setMustChangePassword(data.must_change_password || false);
      } catch (error) {
        window.localStorage.removeItem(TOKEN_KEY);
        setToken(null);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    loadProfile();
  }, [token]);

  const value = useMemo(
    () => ({
      token,
      user,
      loading,
      mustChangePassword,
      setMustChangePassword,
      login: async (username, password) => {
        const { data } = await api.post("/api/auth/login", { username, password }, {timeout: 180000});
        window.localStorage.setItem(TOKEN_KEY, data.token);
        setToken(data.token);
        setUser(data.user);
        setMustChangePassword(data.must_change_password || false);
      },
      logout: () => {
        window.localStorage.removeItem(TOKEN_KEY);
        setToken(null);
        setUser(null);
        setMustChangePassword(false);
      },
      updateUser: (updatedUser) => setUser(updatedUser),
    }),
    [loading, token, user, mustChangePassword]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);